import { all } from "redux-saga/effects";

//public
import AuthenticationSaga from "./authentication/saga";
import SettingsSaga from "./settings/saga";
import ContactsSaga from "./contacts/saga";
import ServicesSaga from "./services/saga";
import WorksSaga from "./works/saga";
import ClientsSaga from "./clients/saga";
import CategoriesSaga from "./categories/saga";
import SubscribersSaga from "./subscribers/saga";
import AdminsSaga from "./admins/saga";
import SocialLinksSaga from "./socialLinks/saga";

export default function* rootSaga() {
  yield all([
    AuthenticationSaga(),
    SettingsSaga(),
    ContactsSaga(),
    ServicesSaga(),
    WorksSaga(),
    ClientsSaga(),
    CategoriesSaga(),
    SubscribersSaga(),
    AdminsSaga(),
    SocialLinksSaga(),
  ]);
}
